import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QueryClientProvider, useQueryClient } from 'react-query';
import { FaSearch } from 'react-icons/fa';
import { useModal } from 'store/modal';
import TooltipWrapper from 'components/TooltipWrapper';
import Button from 'components/Button';
import MassDocEmployees from './MassDocEmployees';

export interface IProps {
  id: string;
}

const MassDocEmployeesDetails: FC<IProps> = ({ id }: IProps) => {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const queryClient = useQueryClient();

  return (
    <div className="d-inline-flex align-items-center">
      <TooltipWrapper
        id="tooltip-mass-doc"
        overlay={t('documents.table.massDoc')}
      >
        <span>{t('documents.table.massDocShort')}</span>
      </TooltipWrapper>
      <div className="d-inline-block ml-2">
        <TooltipWrapper
          id="tooltip-view-all"
          overlay={t('documents.table.viewAllEmployees')}
        >
          <Button
            type="button"
            btnType="icon"
            onClick={e => {
              showModal({
                type: 'info',
                size: 'lg',
                heading: t('documents.table.documentFor'),
                content: (
                  <QueryClientProvider client={queryClient}>
                    <MassDocEmployees id={id} />
                  </QueryClientProvider>
                ),
              });
              e.stopPropagation();
            }}
          >
            <FaSearch
              size={18}
              color="#716aca"
            />
          </Button>
        </TooltipWrapper>
      </div>
    </div>
  );
};

export default MassDocEmployeesDetails;
